import React from 'react'
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@duck/ui'
import { useTar } from '@/modules/i18n'
import { PartnerService } from '@duck/api-definitions'
import {
  EllipsisVerticalIcon,
  PencilIcon,
  PlayIcon,
  PauseIcon,
  TrashIcon,
} from '@heroicons/react/24/outline'

interface AssignmentActionsDropdownProps {
  isActive: boolean
  onEdit: () => void
  onDeleteClick: () => void
  onSetStatus: (status: PartnerService.AssignmentStatus) => void
}

export const AssignmentActionsDropdown: React.FC<AssignmentActionsDropdownProps> = ({
  isActive,
  onEdit,
  onDeleteClick,
  onSetStatus,
}) => {
  const { t } = useTar()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0" onClick={(e) => e.stopPropagation()}>
          <EllipsisVerticalIcon className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onEdit}>
          <PencilIcon className="h-4 w-4" />
          {t('common.edit')}
        </DropdownMenuItem>
        {isActive ? (
          <DropdownMenuItem onClick={() => onSetStatus(PartnerService.AssignmentStatus.Inactive)}>
            <PauseIcon className="h-4 w-4" />
            {t('partner.deactivate')}
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem onClick={() => onSetStatus(PartnerService.AssignmentStatus.Active)}>
            <PlayIcon className="h-4 w-4" />
            {t('partner.activate')}
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={onDeleteClick} className="text-destructive focus:text-destructive">
          <TrashIcon className="h-4 w-4" />
          {t('common.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
